<template>
  <div class="info-header">
    <!-- Carregando o detalhe: skeleton com shimmer (glass) -->
    <div v-if="loading" class="box">
      <div class="icone-status skel skel-avatar"></div>
      <div class="texts-box" style="width:100%">
        <div class="skel skel-line skel-name"></div>
        <div class="skel skel-line skel-email"></div>
        <div class="skel skel-line skel-chip"></div>
      </div>
    </div>

    <div v-else class="box">
      <div class="icone-status" :class="iconStatusClass">
        <span v-if="showInitials" class="icone-initials">{{ initials }}</span>
        <i v-else :class="iconStatusIcon"></i>
        <span v-if="cornerBadge" class="icone-corner" :class="'corner-' + cornerBadge">
          <svg v-if="cornerBadge === 'check'" width="11" height="11" viewBox="0 0 16 16" fill="none">
            <path d="M4 8l3 3 5-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else width="11" height="11" viewBox="0 0 16 16" fill="none">
            <path d="M6 4l5 4-5 4" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div>
      <div class="texts-box text-truncate">
        <div class="text-1 text-truncate">{{ name }}</div>
        <div class="text-2 text-truncate">{{ email }}</div>
        <div v-if="mode === 'checkin'" class="text-2 text-truncate">
          <button
            type="button"
            class="btn btn-outline-dark btn-sm"
            @click="printBadge"
            :disabled="printing"
          >
            <i v-if="printing" class="bx bx-loader-alt bx-spin"></i>
            {{ printing ? 'Carregando...' : 'Imprimir Etiqueta' }}
          </button>
        </div>
        <div v-else class="mode-chip" :class="'mode-chip-' + mode">
          <i :class="mode === 'lead' ? 'bx bx-clipboard' : 'bx bx-gift'"></i>
          {{ mode === 'lead' ? 'Coleta de Lead' : 'Brinde' }}
        </div>
      </div>
    </div>
    <button type="button" class="close text-dark" @click="onClose">
      <img src="@/assets/images/icon/close.svg" alt="fechar"/>
    </button>
  </div>
</template>

<script>
import * as badgeServices from '@/pages/badge-builder/services'
import { errorMessage } from '@/components/alertsMessages'

export default {
  name: 'info-header',
  props: {
    participantId: [String, Number],
    name: String,
    email: String,
    badge_name: String,
    school: String,
    isStatusCheckIn: Boolean,
    isStatusCheckOut: Boolean,
    onClose: Function,
    participant: Object,
    // Modo da estação: 'checkin' | 'lead' | 'brinde'. Em lead/brinde o cabeçalho
    // fica limpo (sem "Imprimir Etiqueta"/status), com o ícone do modo.
    mode: {
      type: String,
      default: 'checkin'
    }
  },
  data: function () {
    return {
      printing: false
    }
  },
  computed: {
    // Todos os modos usam o avatar com iniciais (padrão).
    showInitials () {
      return true
    },
    iconStatusClass () {
      if (this.mode === 'lead') return 'av-lead'
      if (this.mode === 'brinde') return 'av-brinde'
      // Check-in: o badge segue o status (mesmo estilo do card da lista).
      if (this.isStatusCheckIn) return 'av-checkedin'
      if (this.isStatusCheckOut) return 'av-checkedout'
      return 'av-pending'
    },
    // Selo de canto (check/seta) no badge do check-in, igual ao card da lista.
    cornerBadge () {
      if (this.mode !== 'checkin') return null
      if (this.isStatusCheckIn) return 'check'
      if (this.isStatusCheckOut) return 'arrow'
      return null
    },
    // Sem nome ainda = detalhe carregando (a sidebar abre antes do fetch).
    loading () {
      return !this.name
    },
    initials () {
      const n = (this.name || '').trim()
      if (!n) return '' // vazio durante o carregamento (evita "?" piscando)
      const parts = n.split(/\s+/).filter(Boolean)
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    },
    iconStatusIcon () {
      if (this.mode === 'lead') return 'bx bx-clipboard text-white'
      if (this.mode === 'brinde') return 'bx bx-gift text-white'
      if (this.isStatusCheckIn) return 'far fa-check-circle text-white'
      if (this.isStatusCheckOut) return 'bx bx-log-out-circle text-white'
      return 'far fa-question-circle text-white'
    }
  },
  methods: {
    printBadge: function () {
      var self = this

      if (!this.participantId) {
        errorMessage('ID do participante não encontrado')
        return
      }

      this.printing = true

      badgeServices.printBadge(this.participantId)
        .then(function (response) {
          var badgeData = response.data || response

          if (!badgeData || !badgeData.template) {
            errorMessage('Nenhum template de etiqueta configurado. Configure um template padrão no Badge Builder.')
            return
          }

          // Abrir janela de impressão com a etiqueta renderizada
          self.openPrintWindow(badgeData)
        })
        .catch(function (error) {
          console.error('Erro ao carregar etiqueta:', error)
          var message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Erro ao carregar template de etiqueta'
          errorMessage(message)
        })
        .finally(function () {
          self.printing = false
        })
    },

    openPrintWindow: function (badgeData) {
      var printWindow = window.open('', '_blank')

      if (!printWindow) {
        errorMessage('Não foi possível abrir a janela de impressão. Verifique se popups estão permitidos.')
        return
      }

      var html = this.generateBadgeHtml(badgeData)

      printWindow.document.open()
      printWindow.document.write(html)
      printWindow.document.close()
    },

    generateBadgeHtml: function (badgeData) {
      var template = badgeData.template
      var participant = badgeData.participant
      var elements = badgeData.elements || []

      var width = template.width
      var height = template.height
      var bgColor = template.background_color || '#FFFFFF'
      var bgImage = template.background_image

      // Gera HTML dos elementos - passa dimensões da etiqueta para calcular espaço disponível
      var elementsHtml = this.generateElementsHtml(elements, width, height)

      var html = [
        '<!DOCTYPE html>',
        '<html lang="pt-BR">',
        '<head>',
        '  <meta charset="UTF-8">',
        '  <meta name="viewport" content="width=device-width, initial-scale=1.0">',
        '  <title>Imprimir Etiqueta - ' + this.escapeHtml(participant.name) + '</title>',
        '  <style>',
        '    * { margin: 0; padding: 0; box-sizing: border-box; }',
        '    @page { size: ' + width + 'mm ' + height + 'mm; margin: 0; }',
        '    body {',
        '      font-family: Arial, Helvetica, sans-serif;',
        '      background: #e9ecef;',
        '      min-height: 100vh;',
        '      display: flex;',
        '      flex-direction: column;',
        '      align-items: center;',
        '      padding: 30px;',
        '    }',
        '    .print-header { text-align: center; margin-bottom: 20px; }',
        '    .print-header h1 { font-size: 18px; color: #495057; margin-bottom: 5px; }',
        '    .print-header p { font-size: 13px; color: #6c757d; }',
        '    .print-actions { display: flex; gap: 10px; margin-bottom: 25px; }',
        '    .btn {',
        '      display: inline-flex;',
        '      align-items: center;',
        '      gap: 6px;',
        '      padding: 10px 20px;',
        '      border: none;',
        '      border-radius: 6px;',
        '      font-size: 14px;',
        '      font-weight: 500;',
        '      cursor: pointer;',
        '    }',
        '    .btn-primary { background: #556ee6; color: white; }',
        '    .btn-primary:hover { background: #4458cb; }',
        '    .btn-secondary { background: #74788d; color: white; }',
        '    .btn-secondary:hover { background: #5d6071; }',
        '    .badge-container {',
        '      background: white;',
        '      padding: 15px;',
        '      border-radius: 8px;',
        '      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);',
        '    }',
        '    .badge {',
        '      position: relative;',
        '      width: ' + width + 'mm;',
        '      height: ' + height + 'mm;',
        '      background-color: ' + bgColor + ';',
        bgImage ? '      background-image: url(\'' + bgImage + '\');' : '',
        bgImage ? '      background-size: cover;' : '',
        bgImage ? '      background-position: center;' : '',
        '      overflow: hidden;',
        '      border: 1px dashed #dee2e6;',
        '    }',
        '    .print-info { margin-top: 15px; font-size: 12px; color: #868e96; text-align: center; }',
        '    @media print {',
        '      body { background: white; padding: 0; min-height: auto; }',
        '      .no-print { display: none !important; }',
        '      .badge-container { padding: 0; box-shadow: none; border-radius: 0; }',
        '      .badge { border: none; }',
        '    }',
        '    .badge-element { position: absolute; overflow: hidden; }',
        '    .element-text { display: flex; align-items: center; white-space: nowrap; }',
        '    .element-image img, .element-qrcode img { width: 100%; height: 100%; object-fit: contain; }',
        '  </style>',
        '</head>',
        '<body>',
        '  <div class="print-header no-print">',
        '    <h1>Imprimir Etiqueta</h1>',
        '    <p>' + this.escapeHtml(participant.name) + '</p>',
        '  </div>',
        '  <div class="print-actions no-print">',
        '    <button class="btn btn-primary" onclick="window.print()">',
        '      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">',
        '        <path d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/>',
        '        <rect x="6" y="14" width="12" height="8"/>',
        '      </svg>',
        '      Imprimir',
        '    </button>',
        '    <button class="btn btn-secondary" onclick="window.close()">Fechar</button>',
        '  </div>',
        '  <div class="badge-container">',
        '    <div class="badge">' + elementsHtml + '</div>',
        '  </div>',
        '  <div class="print-info no-print">',
        '    Tamanho: ' + width + 'mm x ' + height + 'mm',
        '  </div>',
        '</body>',
        '</html>'
      ].filter(function (line) { return line !== '' }).join('\n')

      return html
    },

    generateElementsHtml: function (elements, labelWidthMm, labelHeightMm) {
      var self = this
      var html = []

      elements.forEach(function (element) {
        if (element.is_visible === false) return

        var elementHtml = self.generateSingleElementHtml(element, labelWidthMm, labelHeightMm, elements)
        if (elementHtml) {
          html.push(elementHtml)
        }
      })

      return html.join('\n')
    },

    generateSingleElementHtml: function (element, labelWidthMm, labelHeightMm, allElements) {
      var PX_TO_MM = 1 / 3.78
      var MARGIN_MM = 2 // Margem de segurança

      // 'wrap' que cresce empurra este pra baixo, sem sobrepor.
      var reflowOffset = allElements ? this.reflowOffsetFor(element, allElements) : 0

      var leftMm = (element.position_x || 0) * PX_TO_MM
      var topMm = ((element.position_y || 0) + reflowOffset) * PX_TO_MM
      var elementWidthMm = (element.width || 20) * PX_TO_MM
      var elementHeightMm = this.elementRenderedHeight(element) * PX_TO_MM

      // Calcular espaço disponível na LARGURA até a borda da etiqueta
      // Altura mantém o tamanho original do elemento para não sobrepor outros
      var availableWidthMm = (element.styles && element.styles.text_fit === 'wrap')
        ? elementWidthMm
        : Math.max(elementWidthMm, labelWidthMm - leftMm - MARGIN_MM)

      var baseStyles = [
        'position: absolute',
        'left: ' + leftMm.toFixed(2) + 'mm',
        'top: ' + topMm.toFixed(2) + 'mm',
        'z-index: ' + (element.z_index || 1)
      ]

      if (element.rotation) {
        baseStyles.push('transform: rotate(' + element.rotation + 'deg)')
      }

      var content = ''
      var additionalStyles = []
      var elementClass = 'badge-element'

      switch (element.type) {
        case 'text':
        case 'dynamic_field':
          elementClass += ' element-text'
          var textValue = element.value || element.content || ''

          // Se for campo de nome (name ou badge_name), aplicar lógica inteligente
          if (this.isNameField(element) && textValue) {
            textValue = this.getSmartNameValue(element, textValue, availableWidthMm, elementHeightMm)
          }

          // Usa espaço disponível para calcular fit e definir dimensões do elemento de texto
          additionalStyles = this.getTextStyles(element, textValue, availableWidthMm.toFixed(2), elementHeightMm.toFixed(2))
          content = this.escapeHtml(textValue)
          // Texto usa largura disponível, mas mantém altura original
          baseStyles.push('width: ' + availableWidthMm.toFixed(2) + 'mm')
          baseStyles.push('height: ' + elementHeightMm.toFixed(2) + 'mm')
          break

        case 'image':
          elementClass += ' element-image'
          var imgSrc = element.content || ''
          if (imgSrc) {
            content = '<img src="' + imgSrc + '" />'
          }
          baseStyles.push('width: ' + elementWidthMm.toFixed(2) + 'mm')
          baseStyles.push('height: ' + elementHeightMm.toFixed(2) + 'mm')
          break

        case 'qrcode':
          elementClass += ' element-qrcode'
          // Usa QR code dinâmico do participante se disponível, senão usa placeholder
          var qrcodeSrc = element.content || require('@/assets/images/qrcode.png')
          content = '<img src="' + qrcodeSrc + '" />'
          baseStyles.push('width: ' + elementWidthMm.toFixed(2) + 'mm')
          baseStyles.push('height: ' + elementHeightMm.toFixed(2) + 'mm')
          break

        case 'photo':
          elementClass += ' element-photo'
          // Usa foto dinâmica do participante se disponível, senão usa placeholder
          if (element.content) {
            content = '<img src="' + element.content + '" style="width:100%;height:100%;object-fit:cover;" />'
          } else {
            content = '<div style="width:100%;height:100%;background:#f0f0f0;display:flex;align-items:center;justify-content:center;font-size:10px;color:#999;">Foto</div>'
          }
          baseStyles.push('width: ' + elementWidthMm.toFixed(2) + 'mm')
          baseStyles.push('height: ' + elementHeightMm.toFixed(2) + 'mm')
          break

        case 'shape':
          additionalStyles = this.getShapeStyles(element)
          baseStyles.push('width: ' + elementWidthMm.toFixed(2) + 'mm')
          baseStyles.push('height: ' + elementHeightMm.toFixed(2) + 'mm')
          break

        default:
          return ''
      }

      var allStyles = baseStyles.concat(additionalStyles).join('; ')

      return '<div class="' + elementClass + '" style="' + allStyles + '">' + content + '</div>'
    },

    getTextStyles: function (element, content, elementWidthMm, elementHeightMm) {
      var PX_TO_MM = 1 / 3.78
      var styles = element.styles || {}
      var widthMm = parseFloat(elementWidthMm)
      var heightMm = parseFloat(elementHeightMm)

      var fontSizePx = styles.font_size || 12
      var fontFamily = styles.font_family || 'Arial, sans-serif'
      var fontWeight = styles.font_bold ? 'bold' : 'normal'
      var fontStyle = styles.font_italic ? 'italic' : 'normal'
      var textAlign = styles.text_align || 'left'
      var fit = styles.text_fit || 'box'

      var alignItems = 'flex-start'
      if (textAlign === 'center') alignItems = 'center'
      else if (textAlign === 'right') alignItems = 'flex-end'

      var base = [
        'display: flex',
        'flex-direction: column',
        'font-family: ' + fontFamily,
        'color: ' + (styles.font_color || '#000000'),
        'font-weight: ' + fontWeight,
        'font-style: ' + fontStyle,
        'text-align: ' + textAlign,
        'align-items: ' + alignItems
      ]

      // WRAP: mantém a fonte e quebra na largura da caixa. BLOCO — num flex o
      // texto vira item dimensionado pelo conteúdo e não quebra.
      if (fit === 'wrap') {
        // NÃO forçar width:100% aqui. Este é um <div> absoluto único (não há
        // container interno), então width:100% resolveria para a LARGURA DA
        // ETIQUETA inteira (containing block = .badge), e o texto só quebraria
        // se estourasse a etiqueta toda — na prática, não quebrava. A largura
        // correta da caixa já foi definida em baseStyles (width: elementWidthMm).
        return [
          'display: block',
          'font-family: ' + fontFamily,
          // font_size é interpretado em PONTOS (igual à térmica/api-printer, que
          // faz font_size * 300/72). Dividir por 3.78 (px de 96dpi) deixava a
          // fonte ~25% menor que a impressa. Usar 'pt' casa o tamanho físico.
          'font-size: ' + fontSizePx + 'pt',
          'line-height: 1.2',
          'color: ' + (styles.font_color || '#000000'),
          'font-weight: ' + fontWeight,
          'font-style: ' + fontStyle,
          'text-align: ' + textAlign,
          'white-space: normal',
          'overflow-wrap: break-word',
          'word-wrap: break-word'
        ]
      }

      // SHRINK: linha única, reduz a fonte só se estourar a largura.
      if (fit === 'shrink') {
        var px = fontSizePx
        var maxPx = widthMm / PX_TO_MM
        var guardShrink = 0
        while (px > 4 && this.measureTextWidthPx(content, px, fontFamily, fontWeight) > maxPx && guardShrink < 200) {
          px -= 0.5
          guardShrink++
        }
        base.push('font-size: ' + (px * PX_TO_MM).toFixed(2) + 'mm')
        base.push('line-height: 1.2')
        base.push('white-space: nowrap')
        base.push('justify-content: center')
        base.push('overflow: hidden')
        base.push('text-overflow: ellipsis')
        return base
      }

      // BOX (padrão): ajusta à caixa.
      var fitResult = this.findOptimalFontSize(content, fontSizePx, widthMm, heightMm, fontFamily, fontWeight)
      base.push('font-size: ' + fitResult.fontSize + 'mm')
      base.push('line-height: ' + fitResult.lineHeight)
      base.push('overflow: hidden')
      if (fitResult.shouldWrap) {
        base.push('white-space: normal')
        base.push('word-wrap: break-word')
        base.push('justify-content: center')
      } else {
        base.push('white-space: nowrap')
        base.push('justify-content: center')
        base.push('text-overflow: ellipsis')
      }
      return base
    },
    // Medição de texto (canvas offscreen) e reflow — espelham o print-queue.
    measureTextWidthPx: function (text, fontPx, fontFamily, fontWeight) {
      if (!this._measureCtx) {
        this._measureCtx = document.createElement('canvas').getContext('2d')
      }
      this._measureCtx.font = (fontWeight || 'normal') + ' ' + fontPx + 'px ' + (fontFamily || 'Arial')
      return this._measureCtx.measureText(text || '').width
    },
    countWrappedLines: function (text, fontPx, fontFamily, fontWeight, maxWidthPx) {
      text = String(text || '').trim()
      if (!text) return 1
      var self = this
      var words = text.split(/\s+/)
      var lines = 1
      var current = ''
      words.forEach(function (word) {
        var candidate = current ? current + ' ' + word : word
        if (self.measureTextWidthPx(candidate, fontPx, fontFamily, fontWeight) <= maxWidthPx || !current) {
          current = candidate
        } else {
          lines++
          current = word
        }
      })
      return lines
    },
    elementRenderedHeight: function (element) {
      var styles = element.styles || {}
      if ((element.type !== 'text' && element.type !== 'dynamic_field') || styles.text_fit !== 'wrap') {
        return element.height
      }
      // Fonte medida na mesma escala do render (pt = font_size * 96/72 em px de
      // 96dpi). Sem isso, a contagem de linhas e a altura ficam subestimadas e a
      // última linha é clipada pelo overflow:hidden da caixa.
      var fontPx = (styles.font_size || 12) * (96 / 72)
      var text = element.value || element.content || ''
      var lines = this.countWrappedLines(text, fontPx, styles.font_family || 'Arial', styles.font_bold ? 'bold' : 'normal', element.width)
      return Math.max(element.height, lines * fontPx * 1.2)
    },
    reflowOffsetFor: function (target, elements) {
      var offset = 0
      var self = this
      elements.forEach(function (g) {
        if (g.id === target.id) return
        var overflow = self.elementRenderedHeight(g) - g.height
        if (overflow > 0 && target.position_y >= g.position_y + g.height) {
          offset += overflow
        }
      })
      return offset
    },

    getShapeStyles: function (element) {
      var styles = element.styles || {}
      var shapeStyles = [
        'background-color: ' + (styles.background_color || 'transparent')
      ]

      if (styles.border_width && styles.border_width > 0) {
        shapeStyles.push('border: ' + styles.border_width + 'px solid ' + (styles.border_color || '#000000'))
      }

      var shapeType = styles.shape_type || 'rectangle'
      if (shapeType === 'circle' || shapeType === 'ellipse') {
        shapeStyles.push('border-radius: 50%')
      } else if (styles.border_radius) {
        shapeStyles.push('border-radius: ' + styles.border_radius + 'px')
      }

      return shapeStyles
    },

    /**
     * Encontra o tamanho de fonte ótimo usando medição real do DOM
     * Abordagem inspirada no textFit: https://github.com/STRML/textFit
     *
     * Estratégia:
     * 1. Tentar fonte original em linha única
     * 2. Se não couber, tentar fonte original com wrap (quebra de linha)
     * 3. Redução de fonte comentada por enquanto
     */
    findOptimalFontSize: function (content, baseFontSizePx, widthMm, heightMm, fontFamily, fontWeight) {
      var PX_TO_MM = 1 / 3.78
      var MM_TO_PX = 3.78
      var baseFontSizeMm = baseFontSizePx * PX_TO_MM
      var LINE_HEIGHT = 1.2

      var result = {
        fontSize: baseFontSizeMm.toFixed(2),
        shouldWrap: false,
        lineHeight: LINE_HEIGHT.toString()
      }

      if (!content || content.length === 0) {
        return result
      }

      // Converter dimensões para pixels para medição
      var containerWidthPx = widthMm * MM_TO_PX
      var containerHeightPx = heightMm * MM_TO_PX

      // Criar elemento de medição invisível
      var measureEl = document.createElement('div')
      measureEl.style.cssText = [
        'position: absolute',
        'visibility: hidden',
        'left: -9999px',
        'top: -9999px',
        'font-family: ' + fontFamily,
        'font-weight: ' + fontWeight,
        'line-height: ' + LINE_HEIGHT,
        'padding: 0',
        'margin: 0',
        'border: 0'
      ].join(';')
      document.body.appendChild(measureEl)

      try {
        // PASSO 1: Testar fonte original em linha única
        measureEl.style.whiteSpace = 'nowrap'
        measureEl.style.width = 'auto'
        measureEl.style.fontSize = baseFontSizePx + 'px'
        measureEl.textContent = content

        var singleLineWidth = measureEl.scrollWidth
        var singleLineHeight = measureEl.scrollHeight

        // Se cabe em linha única com fonte original - perfeito!
        if (singleLineWidth <= containerWidthPx && singleLineHeight <= containerHeightPx) {
          return result
        }

        // PASSO 2: Testar fonte original COM wrap (quebra de linha)
        measureEl.style.whiteSpace = 'normal'
        measureEl.style.wordWrap = 'break-word'
        measureEl.style.width = containerWidthPx + 'px'

        var wrappedHeight = measureEl.scrollHeight

        // Se cabe com wrap na fonte original - usar wrap!
        if (wrappedHeight <= containerHeightPx) {
          result.shouldWrap = true
          return result
        }

        // PASSO 3: Binary search para encontrar maior fonte que cabe com wrap
        var MIN_FONT_SIZE_MM = 2
        var low = MIN_FONT_SIZE_MM * MM_TO_PX
        var high = baseFontSizePx
        var bestFit = low
        var maxIterations = 10

        for (var i = 0; i < maxIterations && low <= high; i++) {
          var mid = Math.floor((low + high) / 2)

          measureEl.style.fontSize = mid + 'px'
          var testHeight = measureEl.scrollHeight

          if (testHeight <= containerHeightPx) {
            bestFit = mid
            low = mid + 1
          } else {
            high = mid - 1
          }
        }

        result.fontSize = (bestFit * PX_TO_MM).toFixed(2)
        result.shouldWrap = true
        return result
      } finally {
        // Sempre remover elemento de medição
        document.body.removeChild(measureEl)
      }
    },

    escapeHtml: function (text) {
      if (text === null || text === undefined) return ''
      var str = String(text)
      var div = document.createElement('div')
      div.textContent = str
      return div.innerHTML
    },

    /**
     * Verifica se o elemento é um campo de nome (name ou badge_name)
     */
    isNameField: function (element) {
      if (element.type !== 'dynamic_field') return false
      var fieldName = element.standard_field_name || element.field_key || ''
      return fieldName === 'name' || fieldName === 'badge_name'
    },

    /**
     * Extrai primeiro e último nome de um nome completo
     * "Maria Clara dos Santos Silva" -> "Maria Silva"
     * "João Pedro" -> "João Pedro"
     * "Ana" -> "Ana"
     */
    getFirstAndLastName: function (fullName) {
      if (!fullName || typeof fullName !== 'string') return fullName || ''

      var parts = fullName.trim().split(/\s+/)

      if (parts.length <= 2) {
        return fullName.trim()
      }

      var firstName = parts[0]
      var lastName = parts[parts.length - 1]

      return firstName + ' ' + lastName
    },

    /**
     * Mede se o texto cabe no container usando medição real do DOM
     * Retorna true se couber, false se não couber
     */
    textFitsInContainer: function (text, fontSizePx, containerWidthPx, containerHeightPx, fontFamily, fontWeight) {
      var measureEl = document.createElement('div')
      measureEl.style.cssText = [
        'position: absolute',
        'visibility: hidden',
        'left: -9999px',
        'top: -9999px',
        'font-family: ' + fontFamily,
        'font-weight: ' + fontWeight,
        'font-size: ' + fontSizePx + 'px',
        'line-height: 1.2',
        'white-space: nowrap',
        'padding: 0',
        'margin: 0',
        'border: 0'
      ].join(';')
      measureEl.textContent = text
      document.body.appendChild(measureEl)

      var fits = measureEl.scrollWidth <= containerWidthPx && measureEl.scrollHeight <= containerHeightPx
      document.body.removeChild(measureEl)

      return fits
    },

    /**
     * Processa nome inteligente: se nome é longo, usa primeiro+último
     * Regra simples: se tem mais de 2 palavras E mais de 20 caracteres, encurta
     */
    getSmartNameValue: function (element, originalValue, widthMm, heightMm) {
      if (!originalValue || typeof originalValue !== 'string') {
        return originalValue || ''
      }

      var parts = originalValue.trim().split(/\s+/)
      var MAX_CHARS = 20 // Limite de caracteres para nome completo

      // Se tem mais de 2 palavras E é muito longo, encurta
      if (parts.length > 2 && originalValue.length > MAX_CHARS) {
        return this.getFirstAndLastName(originalValue)
      }

      return originalValue
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";

.icone-status {
  position: relative;
  box-sizing: border-box;
  width: 70px;
  height: 70px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background-color: #6B7280;
  color: #fff;
  font-size: 36px;
  flex-shrink: 0;
  margin-right: 12px;

  /* Lead: iniciais em azul claro */
  &.av-lead { background-color: #eef1fe; color: #4f6ef7; }

  /* Brinde: iniciais em âmbar */
  &.av-brinde { background-color: #fff3e0; color: #e8860c; }

  /* Check-in: segue o status (mesmo estilo do card da lista) */
  &.av-pending { background-color: #d1d5db; color: #6b7280; }
  &.av-checkedin {
    background-color: rgba(16, 185, 129, 0.12);
    color: #10b981;
    border: 2px solid rgba(16, 185, 129, 0.35);
  }
  &.av-checkedout {
    background-color: rgba(234, 138, 23, 0.12);
    color: #ea8a17;
    border: 2px solid rgba(234, 138, 23, 0.35);
  }

  /* Brinde: ícone sobre fundo âmbar */
  &.is-mode-brinde { background-color: #F1B44C; }

  .icone-initials {
    font-size: 24px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 0.02em;
  }

  .icone-corner {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    color: #fff;
    box-shadow: 0 0 0 2.5px #fff;

    &.corner-check { background: #10b981; }
    &.corner-arrow { background: #ea8a17; }
  }
}

.mode-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  padding: 3px 10px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;

  &.mode-chip-lead {
    background: rgba(85, 110, 230, 0.14);
    color: #556ee6;
  }

  &.mode-chip-brinde {
    background: rgba(241, 180, 76, 0.18);
    color: #b8801f;
  }
}

.texts-box {
  flex-basis: 0;
  flex-grow: 1;
  min-width: 0; /* essencial p/ o text-truncate encolher dentro do flex */
  max-width: 100%;
  .text-1 {
    font-size: 20px;
    color: #05162B;
  }

  .text-2 {
    font-size: 14px;
    color: #05162B87;
  }
}

.info-header {
  --padding: 25px 20px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 29px 34px;
  }

  display: flex;
  flex: 1;
  width: 100%;
  padding: var(--padding);
  .box {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;        /* permite o texto encolher e truncar */
    flex-wrap: wrap;
    padding-right: 14px; /* folga antes do botão fechar */
  }
  .close {
    align-self: flex-start;
    flex-shrink: 0;
    opacity: 1;
  }
}

/* ── Skeleton de carregamento (glass shimmer) ── */
.skel {
  position: relative;
  overflow: hidden;
  background: #eef1f6;
}
.skel::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.65), transparent);
  animation: skel-shimmer 1.3s ease-in-out infinite;
}
@keyframes skel-shimmer {
  100% { transform: translateX(100%); }
}
.skel-avatar {
  background: #eef1f6 !important; /* sobrepõe a cor de status do .icone-status */
}
.skel-line {
  height: 14px;
  border-radius: 6px;
  margin-bottom: 9px;
}
.skel-name { width: 55%; height: 18px; }
.skel-email { width: 72%; }
.skel-chip { width: 42%; margin-bottom: 0; }
</style>
